export default {
  id: 'faq',
  title: 'Česta pitanja (FAQ)',
  icon: 'mdi-help-circle',
  show: true,
  order: 17,
  content: () => `
    <h2>Česta pitanja (FAQ)</h2>
    <p>Odgovori na najčešća pitanja korisnika.</p>

    <h3 class="mt-6">📱 Prijava i login</h3>
    <details class="faq-item">
      <summary>Zaboravio sam lozinku - što sad?</summary>
      <p>
        Na stranici za prijavu kliknite na "Zaboravili ste lozinku?" link.
        Unesite svoj email i slijedite upute koje ćete dobiti emailom.
      </p>
    </details>

    <details class="faq-item">
      <summary>Ne mogu se prijaviti u aplikaciju</summary>
      <p>
        Provjerite sljedeće:
      </p>
      <ul>
        <li>Jeste li upisali ispravan email?</li>
        <li>Pazite na velika i mala slova u lozinki</li>
        <li>Provjerite internetsku vezu</li>
        <li>Pokušajte obrisati cache preglednika</li>
        <li>Kontaktirajte podršku ako problem perzistira</li>
      </ul>
    </details>

    <h3 class="mt-6">🧾 Fiskalizacija</h3>
    <details class="faq-item">
      <summary>Račun nije fiskaliziran - što sad?</summary>
      <p>
        Ako račun nije uspješno fiskaliziran:
      </p>
      <ol>
        <li>Idite na stranicu "Računi"</li>
        <li>Pronađite račun sa statusom "FAILED"</li>
        <li>Provjerite internetsku vezu</li>
        <li>Provjerite valjanost FINA certifikata</li>
        <li>Kliknite na gumb "Ponovna fiskalizacija"</li>
      </ol>
    </details>

    <details class="faq-item">
      <summary>Nema JIR koda na računu</summary>
      <p>
        JIR kod se dodjeljuje samo nakon uspješne fiskalizacije. Ako račun nema JIR,
        to znači da fiskalizacija nije uspjela ili da je riječ o predračunu/ponudi
        koje se ne fiskaliziraju.
      </p>
    </details>

    <details class="faq-item">
      <summary>FINA server ne odgovara</summary>
      <p>
        Ponekad FINA serveri mogu biti nedostupni zbog maintanance-a ili prekida.
        Pričekajte nekoliko minuta i pokušajte ponovno. Ako problem perzistira,
        provjerite na FINA web stranici ima li najava održavanja.
      </p>
    </details>

    <h3 class="mt-6">💰 Blagajna</h3>
    <details class="faq-item">
      <summary>Pisač ne ispisuje račune</summary>
      <p>
        Provjerite sljedeće:
      </p>
      <ul>
        <li>Je li pisač uključen i spojen na mrežu?</li>
        <li>Ima li papira u pisaču?</li>
        <li>Je li pisač pravilno konfiguriran u postavkama?</li>
        <li>Pokušajte test ispis iz postavki pisača</li>
      </ul>
    </details>

    <details class="faq-item">
      <summary>Artikl nema cijenu</summary>
      <p>
        Svaki artikal mora imati postavljenu cijenu na cjeniku za prodajno mjesto
        gdje radite. Idite na "Cjenik" i dodajte artikal sa cijenom.
      </p>
    </details>

    <details class="faq-item">
      <summary>Ne mogu stornirati račun</summary>
      <p>
        Storno računa mogu izvršiti samo korisnici sa odgovarajućim privilegijama.
        Također, mogu se stornirati samo fiskalizirani računi. Ako nemate privilegije,
        kontaktirajte administratora.
      </p>
    </details>

    <details class="faq-item">
      <summary>Kako zatvoriti smjenu?</summary>
      <p>
        Zatvaranje smjene (Close Balance):
      </p>
      <ol>
        <li>Kliknite gumb "Zatvori smjenu" na blagajni</li>
        <li>Unesite stvarno stanje gotovine u blagajni</li>
        <li>Pregledajte izvještaj prometa</li>
        <li>Kliknite "Završi" za ispis izvještaja</li>
      </ol>
    </details>

    <h3 class="mt-6">📦 Skladište</h3>
    <details class="faq-item">
      <summary>Stanje se ne ažurira nakon prodaje</summary>
      <p>
        Provjerite je li artikal povezan sa skladišnom jedinicom (warehouse unit).
        Samo artikli sa warehouse unit-om automatski smanjuju zalihe nakon prodaje.
      </p>
    </details>

    <details class="faq-item">
      <summary>Kako dodati primku?</summary>
      <p>
        Dodavanje primke:
      </p>
      <ol>
        <li>Idite na "Skladište" → "Primka"</li>
        <li>Kliknite "+ Dodaj primku"</li>
        <li>Odaberite dobavljača</li>
        <li>Dodajte artikle i količine</li>
        <li>Unesite cijene</li>
        <li>Kliknite "Spremi i odobri"</li>
      </ol>
    </details>

    <details class="faq-item">
      <summary>Razlika između primke i izdatnice?</summary>
      <p>
        <strong>Primka:</strong> Dokument za ulaz robe u skladište (povećava zalihe)<br>
        <strong>Izdatnica:</strong> Dokument za izlaz robe iz skladišta (smanjuje zalihe)
      </p>
    </details>

    <details class="faq-item">
      <summary>Kako napraviti inventuru?</summary>
      <p>
        Inventura:
      </p>
      <ol>
        <li>Idite na "Skladište" → "Inventura"</li>
        <li>Kliknite "Pokreni inventuru"</li>
        <li>Odaberite tip (potpuna ili parcijalna)</li>
        <li>Unesite stvarno prebrojano stanje za svaki artikal</li>
        <li>Pregledajte razlike (manjak/višak)</li>
        <li>Kliknite "Zaključi inventuru"</li>
      </ol>
    </details>

    <h3 class="mt-6">📊 Izvještaji</h3>
    <details class="faq-item">
      <summary>Izvještaj je prazan</summary>
      <p>
        Provjerite jeste li odabrali ispravan datumski raspon.
        Također, provjerite filter postavke - možda ste filtrirali podatke
        koji ne postoje.
      </p>
    </details>

    <details class="faq-item">
      <summary>Podaci se ne poklapaju</summary>
      <p>
        Ako se podaci u izvještaju ne poklapaju sa očekivanim:
      </p>
      <ul>
        <li>Provjerite datumski raspon</li>
        <li>Provjerite filter postavke</li>
        <li>Osvježite stranicu</li>
        <li>Kontaktirajte podršku ako problem perzistira</li>
      </ul>
    </details>

    <details class="faq-item">
      <summary>Kako izvesti u Excel?</summary>
      <p>
        Većina izvještaja ima gumb "Izvezi" ili "Export" koji omogućava
        preuzimanje podataka u CSV ili Excel format.
      </p>
    </details>
  `
}
